import { render, staticRenderFns } from "./pastImageViewer.vue?vue&type=template&id=2e7f7119"
import script from "./pastImageViewer.vue?vue&type=script&lang=js"
export * from "./pastImageViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports